
    <style scoped>
        
        .page-content {
            flex: 1;
            
            overflow-y: auto;
            padding-bottom: 70px;
        }
        
        /* 头部信息 */
        .header-info {
            background: white;
            border-radius: 16px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
        }
        .info-item {
            display: flex;
            margin-bottom: 15px;
        }
        .info-item:last-child {
            margin-bottom: 0;
        }
        .info-label {
            width: 100px;
            color: #666;
            font-size: 15px;
        }
        .info-value {
            flex: 1;
            font-size: 15px;
            font-weight: 500;
            color: #333;
        }
        
        /* 表单样式 */
        .collection-form {
            background: white;
            border-radius: 16px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
        }
        .form-title {
            font-size: 18px;
            font-weight: 600;
            color: #3498db;
            margin-bottom: 20px;
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }
        .form-group {
            margin-bottom: 20px;
        }
        .form-label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
            color: #555;
        }
        .tooth-selection {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
        }
        .tooth-option {
            border: 1px solid #ddd;
            border-radius: 8px;
            padding: 10px 5px;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s;
        }
        .tooth-option.selected {
            border-color: #3498db;
            background: #e8f4fc;
            color: #3498db;
            font-weight: 500;
        }
        .tooth-option:hover {
            border-color: #3498db;
        }
        .time-display {
            padding: 12px 15px;
            background: #f8f9fa;
            border-radius: 8px;
            font-size: 15px;
            color: #555;
        }
        .collection-method {
            display: flex;
            flex-direction: column;
            gap: 15px;
        }
        .method-option {
            display: flex;
            align-items: flex-start;
        }
        .method-radio {
            margin-right: 10px;
            margin-top: 3px;
        }
        .method-details {
            flex: 1;
        }
        .method-title {
            font-weight: 500;
            margin-bottom: 5px;
        }
        .method-input {
            width: 100%;
            padding: 10px 15px;
            border: 1px solid #ddd;
            border-radius: 8px;
            font-size: 14px;
            margin-top: 5px;
        }
        .method-input:focus {
            border-color: #3498db;
            outline: none;
            box-shadow: 0 0 0 2px rgba(52,152,219,0.2);
        }
        .submit-btn {
            background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%);
            color: white;
            border: none;
            border-radius: 10px;
            padding: 15px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            width: 100%;
            transition: all 0.3s;
            margin-top: 10px;
        }
        .submit-btn:hover {
            opacity: 0.9;
            transform: translateY(-2px);
        }
        
        /* 底部导航栏 */
        .tab-bar {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 60px;
            background: white;
            display: flex;
            justify-content: space-around;
            align-items: center;
            border-top: 1px solid #eee;
            box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
            z-index: 100;
            max-width: 420px;
            margin: 0 auto;
        }
        .tab-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1;
            height: 100%;
            cursor: pointer;
            transition: all 0.3s;
            color: #999;
        }
        .tab-item.active {
            color: #3498db;
        }
        .tab-icon {
            font-size: 20px;
            margin-bottom: 4px;
        }
        .tab-name {
            font-size: 12px;
        }
    </style>
 
    <template >
         
            <div class="page-content">
                <!-- 头部信息 -->
                <div class="header-info">
                    <div class="info-item">
                        <div class="info-label">姓名：</div>
                        <div class="info-value">张三</div>
                    </div>
                    <div class="info-item">
                        <div class="info-label">乳牙采集盒：</div>
                        <div class="info-value">BS0000111111</div>
                    </div>
                </div>
                
                <!-- 采集表单 -->
                <div class="collection-form">
                    <div class="form-title">乳牙采集信息</div>
                    
                    <div class="form-group">
                        <label class="form-label">采集牙位：</label>
                        <div class="tooth-selection">
                            <div class="tooth-option" 
                                 v-for="tooth in toothOptions" 
                                 :key="tooth"
                                 :class="{selected: formData.toothPosition === tooth}"
                                 @click="formData.toothPosition = tooth">
                                {{ tooth }}
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <label class="form-label">采集时间：</label>
                        <div class="time-display">
                            {{ currentTime }}
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <label class="form-label">采集方式：</label>
                        <div class="collection-method">
                            <div class="method-option">
                                <input type="radio" id="medical" value="medical" v-model="formData.collectionMethod" class="method-radio">
                                <div class="method-details">
                                    <label for="medical" class="method-title">医疗机构采集</label>
                                    <input type="text" class="method-input" placeholder="请输入医院名称" 
                                           v-model="formData.hospitalName" 
                                           :disabled="formData.collectionMethod !== 'medical'">
                                </div>
                            </div>
                            
                            <div class="method-option">
                                <input type="radio" id="natural" value="natural" v-model="formData.collectionMethod" class="method-radio">
                                <div class="method-details">
                                    <label for="natural" class="method-title">自然脱落（家、学校、其他）</label>
                                    <input type="text" class="method-input" placeholder="请输入具体地点" 
                                           v-model="formData.naturalLocation" 
                                           :disabled="formData.collectionMethod !== 'natural'">
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <button class="submit-btn" @click="submitForm">提交</button>
                </div>
            </div>
            
             
        
    </template>

    <script>
       export default {
    name: 'Caiji',
            
            data() {return {
                currentTab: 'cell',
                currentTime: this.getCurrentTime(),
                toothOptions: [
                    '左上A', '左上B', '左上C', '左上D', '左上E',
                    '右上A', '右上B', '右上C', '右上D', '右上E',
                    '左下A', '左下B', '左下C', '左下D', '左下E',
                    '右下A', '右下B', '右下C', '右下D', '右下E'
                ],
                formData: {
                    toothPosition: '',
                    collectionMethod: 'medical',
                    hospitalName: '',
                    naturalLocation: ''
                }
            }},
            methods: {
                getCurrentTime() {
                    const now = new Date();
                    const year = now.getFullYear();
                    const month = String(now.getMonth() + 1).padStart(2, '0');
                    const day = String(now.getDate()).padStart(2, '0');
                    const hours = String(now.getHours()).padStart(2, '0');
                    const minutes = String(now.getMinutes()).padStart(2, '0');
                    
                    return `${year}年${month}月${day}日${hours}时${minutes}分`;
                },
                submitForm() {
                    // 表单验证
                    if (!this.formData.toothPosition) {
                        alert('请选择采集牙位');
                        return;
                    }
                    
                    if (this.formData.collectionMethod === 'medical' && !this.formData.hospitalName) {
                        alert('请输入医院名称');
                        return;
                    }
                    
                    if (this.formData.collectionMethod === 'natural' && !this.formData.naturalLocation) {
                        alert('请输入自然脱落的具体地点');
                        return;
                    }
                    
                    // 提交表单数据
                    console.log('提交数据:', this.formData);
                    alert('采集信息提交成功！');
                    
                    // 实际应用中：发送数据到服务器
                },
                
            }
        };
    </script>